import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import './features24.css'
import image3 from '../images/IMG-20241102-WA0000.jpg'
import image2 from '../images/IMG-20241102-WA0002.jpg'
import image1 from '../images/picnicOpale.jpeg'


const Features24 = () => {
    const {t} = useTranslation()
    const [activeTab, setActiveTab] = useState(0) // activeTab 0 for block 1, 1 for block 2, 2 for block 3
    return (
        <div className="thq-section-padding">
            <div className="features24-container2 thq-section-max-width">
                <div className="features24-image-container">
                    {activeTab === 0 && ( /* Block 1 Image */
                        <img
                            alt={t('features24.alt1')}
                            src={image1}
                            className="features24-image1 thq-img-ratio-16-9"
                        />
                    )}
                    {activeTab === 1 && ( /* Block 2 Image */
                        <img
                            alt={t('features24.alt2')}
                            src={image2}
                            className="features24-image2 thq-img-ratio-16-9"
                        />
                    )}
                    {activeTab === 2 && ( /* Block 3 Image */
                        <img
                            alt={t('features24.alt3')}
                            src={image3}
                            className="features24-image3 thq-img-ratio-16-9"
                        />
                    )}
                </div>
                <div className="features24-tabs-menu">
                    {/* New Block 1 (Content for title1, desc1) - uses classes from original block 3 */}
                    <div
                        onClick={() => setActiveTab(0)}
                        className="features24-tab-horizontal3"
                    >
                        <div className="features24-divider-container3">
                            {activeTab === 0 && <div className="features24-container5"></div>}
                        </div>
                        <div className="features24-content1">
                            <h2 className="thq-heading-2">
                                <span className="features24-text1">{t('features24.title1')}</span>
                            </h2>
                            <span className="thq-body-small">
                                <span className="features24-text4">{t('features24.desc1')}</span>
                            </span>
                        </div>
                    </div>
                    {/* New Block 2 (Content for title2, desc2) - uses classes from original block 1 */}
                    <div
                        onClick={() => setActiveTab(1)}
                        className="features24-tab-horizontal1"
                    >
                        <div className="features24-divider-container1">
                            {activeTab === 1 && <div className="features24-container3"></div>}
                        </div>
                        <div className="features24-content2">
                            <h2 className="thq-heading-2">
                                <span className="features24-text5">{t('features24.title2')}</span>
                            </h2>
                            <span className="thq-body-small">
                                <span className="features24-text2">{t('features24.desc2')}</span>
                            </span>
                        </div>
                    </div>
                    {/* New Block 3 (Content for title3, desc3) - uses classes from original block 2 */}
                    <div
                        onClick={() => setActiveTab(2)}
                        className="features24-tab-horizontal2"
                    >
                        <div className="features24-divider-container2">
                            {activeTab === 2 && <div className="features24-container4"></div>}
                        </div>
                        <div className="features24-content3">
                            <h2 className="thq-heading-2">
                                <span className="features24-text6">{t('features24.title3')}</span>
                            </h2>
                            <span className="thq-body-small">
                                <span className="features24-text3">{t('features24.desc3')}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Features24
